/**
 * Format "Pagina aandeel" for display: show decimals as fractions (e.g. 0.125 → "1/8").
 * Values that are already fractions (e.g. "1/8") are returned unchanged.
 */

const gcd = (a, b) => {
  a = Math.abs(Math.round(a));
  b = Math.abs(Math.round(b));
  if (!b) return a;
  return gcd(b, a % b);
};

/**
 * Convert a decimal number to a simplified fraction string (e.g. 0.125 → "1/8").
 * @param {number} num
 * @returns {string}
 */
export const decimalToFraction = (num) => {
  if (num === 0) return '0';
  if (Number.isInteger(num)) return String(num);
  const sign = num < 0 ? -1 : 1;
  num = Math.abs(num);
  const tolerance = 1e-10;
  let denominator = 1;
  while (denominator <= 10000) {
    const numerator = Math.round(num * denominator);
    if (Math.abs((numerator / denominator) - num) < tolerance) {
      const d = gcd(numerator, denominator);
      const n = (sign * numerator) / d;
      const den = denominator / d;
      if (den === 1) return String(n);
      return `${n}/${den}`;
    }
    denominator += 1;
  }
  return String(num);
};

/**
 * Return display string for Aandeel: fraction form.
 * - If value is already a fraction string (contains "/"), return it trimmed.
 * - If value is a decimal number (or numeric string), convert to fraction.
 * @param {string|number} value - Raw Aandeel value from data (e.g. "1/8", 0.125, "0.125")
 * @returns {string}
 */
export const formatAandeelDisplay = (value) => {
  if (value === null || value === undefined) return '';
  const s = String(value).trim();
  if (!s) return '';
  if (s.includes('/')) return s;
  const num = parseFloat(s.replace(',', '.'));
  if (Number.isNaN(num)) return s;
  return decimalToFraction(num);
};
